export default function Header() {
  return (
    <header className="header">
      <h1>🌴 Before going to travel 🧳</h1>
    </header>
  );
}
